import React, { useState, useEffect } from "react"; 
import { FaUsers, FaHistory, FaPlus, FaEdit, FaTrashAlt } from "react-icons/fa";
import Menu from "./Menu";
import "./admin.css";
import AddUserModal from "./AddUserModal";
import EditUserModal from "./EditUserModal";

const Admin = () => {
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState(""); 
    const [showModal, setShowModal] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);


    const toggleStatus = (userId) => {
      setUsers((prev) =>
        prev.map((u) =>
          u.id === userId ? { ...u, active: !u.active } : u
        )
      );
    };

  // Récupérer les utilisateurs depuis la base de données//////////////////////////
  useEffect(() => {
    fetch("https://api.qunciland.com/api/users") 
      .then((res) => res.json())
      .then((data) => setUsers(data))
      .catch((err) => console.error(err));
  }, []);

  ///////////////////////////////////////////////////////////////////////////////

 const filteredUsers = users.filter(user =>
  (user.username || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
  (user.email || "").toLowerCase().includes(searchTerm.toLowerCase())
);

////////////////////////////////////////////////////////////////////////////////


  const handleAddUser = (newUser) => {
  const payload = {
    username: newUser.username,
    email: newUser.email,
    mot_de_passe: newUser.mot_de_passe, 
    role: newUser.role,
    active: true
  };

  fetch("https://api.qunciland.com/api/add/users", {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("token")}`
    },
    body: JSON.stringify(payload),
  })
  .then((res) => res.json())
  .then((createdUser) => {
    const userForFront = {
      id: createdUser.id,
      username: createdUser.username || "-",
      email: createdUser.email,
      role: createdUser.role,
      active: createdUser.active,
      date_creation: new Date()
    };
    setUsers([...users, userForFront]);
    setShowModal(false);
  })
  .catch((err) => console.error("Erreur lors de l’ajout :", err));
};

//////////////////////////////////////////////////////////////////////////////////


  const handleUpdateUser = (updatedUser) => {
  fetch(`https://api.qunciland.com/api/edit/users/${updatedUser.id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updatedUser),
  })
    .then((res) => res.json())
    .then((data) => {
      setUsers(users.map(u => u.id === data.id ? data : u));
      setShowEditModal(false);
    })
    .catch(err => console.error("Erreur lors de la modification :", err));
};



///////////////////////////////////////////////////////////////////////////////////

const handleDeleteUser = (userId) => {
  if (!window.confirm("Voulez-vous vraiment supprimer cet utilisateur ?")) return;

  fetch(`https://api.qunciland.com/api/users/${userId}`, {
    method: "DELETE",
    headers: { 
      "Authorization": `Bearer ${localStorage.getItem("token")}`
    },
  })
  .then((res) => {
    if (!res.ok) throw new Error("Erreur lors de la suppression");
    return res.json();
  })
  .then(() => {
    setUsers(prev => prev.filter(u => u.id !== userId));
  })
  .catch((err) => console.error(err));
};





  return (
    <div>
      <Menu />
      <div className="contentWrapper">

        <nav className="sidebar">
          <div className="sidebarContent">
            <button className="navButton active">
              <FaUsers style={{ marginRight: "8px" }} />
              Gestion des utilisateurs
            </button>

            
          </div>
        </nav>

        <main className="mainContent">
          <div className="card">
            <div className="cardBody">
         
              <div className="toolbar">
                <div className="searchGroup">
                  <input
                    type="text"
                    className="searchInput"
                    placeholder="Rechercher un utilisateur..."
                    value={searchTerm} 
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <button className="searchButton">🔍</button>
                </div>

               <div className="actionButtons">
                <button className="addButton" onClick={() => setShowModal(true)}>
                  <FaPlus style={{ marginRight: "8px" }} />
                  Ajouter un utilisateur
                </button>

                {showModal && (
                  <AddUserModal 
                    onClose={() => setShowModal(false)}
                    onAddUser={handleAddUser} 
                  />
                )}
              </div>

              </div>

              <div className="tableResponsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Nom</th>
                      <th>Email</th>
                      <th>Rôle</th>
                      <th>Date création</th>
                      <th>Statut</th>
                      <th className="textCenter">Actions</th>
                    </tr>
                  </thead>
                   <tbody>
                    {filteredUsers.length === 0 ? (
                        <tr>
                        <td colSpan="7" className="noResults">
                            Aucun utilisateur trouvé.
                        </td>
                        </tr>
                    ) : (
                        filteredUsers.map((user) => (
                        <tr key={user.id}>
                            <td>{user.username || "-"}</td>
                            <td>{user.email}</td>
                            <td><span className="badge">{user.role}</span></td>
                            <td>
                            {new Date(user.date_creation).toLocaleDateString('fr-FR', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                              })}
                            </td>
                            <td>
                            <button
                                className={`statusButton ${user.active ? "deactivate" : "activate"}`}
                                onClick={() => toggleStatus(user.id)}
                            >
                                {user.active ? "Désactiver" : "Activer"}
                            </button>
                            </td>
                            <td className="textCenter">
                            <button
                            className="editButton"
                            onClick={() => {
                              setEditingUser(user);
                              setShowEditModal(true);
                            }}
                          >
                            <FaEdit style={{ color: "blue", width: "17px", height: "17px" }} />
                          </button>
                          {showEditModal && editingUser && (
                          <EditUserModal
                            user={editingUser}
                            onClose={() => setShowEditModal(false)}
                            onUpdateUser={handleUpdateUser}
                          />
                        )}
                            <button 
                            className="deleteButton" 
                            onClick={() => handleDeleteUser(user.id)}
                          >
                            <FaTrashAlt style={{ width: "17px", height: "17px", color: "red" }} />
                          </button>

                            </td>
                        </tr>
                        ))
                    )}
                    </tbody>

                </table>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Admin;
